import React from "react";

const LeftIcon = () => {
  return (
    <div>
      <svg
        fill="#000000"
        height="16"
        width="16"
        version="1.1"
        id="Layer_1"
        viewBox="0 0 511.955 511.955"
      >
        <g>
          <g>
            <path
              d="M511.813,254.103c-0.96-5.227-5.653-8.853-10.88-8.853H36.293l195.2-195.093c4.053-4.267,3.947-10.987-0.213-15.04
			c-4.16-3.947-10.667-3.947-14.827,0L3.12,248.45c-4.16,4.16-4.16,10.88,0,15.04l213.333,213.333
			c4.267,4.053,10.987,3.947,15.04-0.213c3.947-4.16,3.947-10.667,0-14.827l-195.2-195.2h464.96
			C507.76,266.583,512.88,260.717,511.813,254.103z"
            />
          </g>
        </g>
      </svg>
    </div>
  );
};

export default LeftIcon;
